<template>
  <div class="wms">
    <div class="t_header" v-if="w_width<888">
      <div class="fx_cs t_topbar">
        <img src="../assets/img/homepage/logotop.png" style="height: 28px" />
        <i class="iconfont iconzu1714" style="color: #FFFFFF" @click="change()"></i>
      </div>
      <div class="t_maindiv1" style="height: 340px">
        <img src="../assets/img/bg/11.jpg" style="height: 340px">
        <div class="t_mes">
          <img src="../assets/img/24.png" style="width: 122px">
          <div class="t_title">
            <div>TMIP产品体系</div>
            <div>WMS 智慧仓储</div>
            <div />
          </div>
        </div>
      </div>
    </div>
    <div class="header" v-else>
      <div class="topbar">
        <img src="../assets/img/homepage/logotop.png" />
        <myheader></myheader>
      </div>
      <div class="widtol mesdiv1">
        <div class="mesdiv2">
          <span class="messp1">TMIP产品体系</span>
          <span class="messp2">WMS 智慧仓储</span>
        </div>
        <div class="mesdiv3">
          <img src="../assets/img/24.png" style="width: 266px; height: 274px" />
        </div>
      </div>
    </div>
    <div class="t_maindiv1" style="height: 354px" v-if="w_width<888">
      <img src="../assets/img/bg/2.jpg" style="height: 354px;">
      <div class="t_txt9">
        <div>
          根据实际货物存储的要求（集中存放、先进先出等），由系统自动规划入仓存放、出仓配货库位。
        </div>
        <div style="margin-top: 20px">
          提高仓库利用率，合理安排库区库位 货品、单据、库位条码化管理，实现货品入库、出库、调拨、移库移位、盘点等各个环节进行自动化数据采集，保证仓库管理各环节数据输入的高效及准确，确保企业及时准确地掌握库存的真实数据，合理保持和控制企业库存。通过科学的编码，还可方便地进行物品的批次、保质期等进行管理
        </div>
        <div style="margin-top: 20px">
          基于3D虚拟现实技术，实现3D仓库的可视化管理，快速定位，提升作业效率。
        </div>
      </div>
    </div>
    <div class="mesdiv4" v-else>
      <div class="widtol mesdiv5">
        <span class="messp3">WMS 智慧仓储</span>
        <span class="messp4">
          根据实际货物存储的要求（集中存放、先进先出等），由系统自动规划入仓存放、出仓配货库位。提高仓库利用率，<br />
          合理安排库区库位。<br />
           货品、单据、库位条码化管理，实现货品入库、出库、调拨、移库移位、盘点等各个环节进行自动化数据采集，保证<br />
           仓库管理各环节数据输入的高效及准确，确保企业及时准确地掌握库存的真实数据，合理保持和控制企业库存。通过<br />
           科学的编码，还可方便地进行物品的批次、保质期等进行管理 基于3D虚拟现实技术，实现3D仓库的可视化管理，<br />
           快速定位，提升作业效率。
          </span
        >
      </div>
    </div>

    <div v-if="w_width<888">
      <div class="t_mes_info">
        <div class="t_mes_txt">核心模块</div>
        <img src="../assets/img/13.png" style="width: 100%;">
        <div class="t_mes_txt2">全面条码管理，统一规范</div>
        <div class="t_mes_txt3">
          仓库物料一物一码，设定合理的规范的物料条码，规范作业管理流程。托盘、箱、载具等也采用统一规范条码、RFID进行管理
        </div>
      </div>
      <div class="t_mes_info" style="background: #FFFFFF">
        <img src="../assets/img/14.png" style="width: 100%;">
        <div class="t_mes_txt2">手持终端操作，高效便捷</div>
        <div class="t_mes_txt3">
          支持手持终端操作所有仓库作业，包括入库、出库、回库、返库、盘点等，每次出入库的数据都进行验证，确保数据的正确性，大大提高了仓库作业的便捷性及作业效率
        </div>
      </div>
      <div class="t_mes_info">
        <img src="../assets/img/15.png" style="width: 100%;">
        <div class="t_mes_txt2">支持库存预警</div>
        <div class="t_mes_txt3">
          支持安全库存预警，保质期预警，超库龄预警，物料齐套预警等可通过邮件、系统通知等提醒相关人员
        </div>
      </div>
    </div>
    <div class="mesdiv6" v-else>
      <span class="messp5">核心功能</span>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8 txt-left">
          <img src="../assets/img/13.png" style="width: 477px; height: 318px" />
        </div>
        <div class="mesdiv8">
          <div class="mesdiv9">
            <span class="messp6">全面条码管理，统一规范</span>
            <span class="messp7">仓库物料一物一码，设定合理的规范的物料条码，规范作业管理流程。<br>
            托盘、箱、载具等也采用统一规范条码、RFID进行管理</span>
          </div>
        </div>
      </div>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8">
          <div class="mesdiv9" style="margin-left: 60px; padding-left: 0px">
            <span class="messp6">手持终端操作，高效便捷</span>
            <span class="messp7">支持手持终端操作所有仓库作业，包括入库、出库、回库、返库、盘点<br>
            等，每次出入库的数据都进行验证，确保数据的正确性，大大提高了仓<br>
            库作业的便捷性及作业效率。</span>
          </div>
        </div>
        <div class="mesdiv8 txt-right">
          <img src="../assets/img/14.png" style="width: 435px; height: 314px" />
        </div>
      </div>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8 txt-left">
          <img src="../assets/img/15.png" style="width: 471px; height: 277px" />
        </div>
        <div class="mesdiv8">
          <div class="mesdiv9">
            <span class="messp6">支持库存预警</span>
            <span class="messp7">支持安全库存预警，保质期预警，超库龄预警，物料齐套预警等可通过<br>
            邮件、系统通知等提醒相关人员</span>
          </div>
        </div>
      </div>
    </div>

    <div class="t_maindiv1" style="height: 514px" v-if="w_width<888">
      <img src="../assets/img/bg/5.jpg" style="height: 514px">
      <div class="t_wms_info">
        <div class="t_wms_txt1">3D建模，<br>让数据触手可及</div>
        <div class="t_wms_txt2">
          基于3D虚拟现实技术，实现3D仓库的可视化管理，实现库房3D立体巡游。配合后台数据及掌机操作，实时展示仓库数据，直观展示仓库当前使用状况
        </div>
        <img src="../assets/img/16.png" class="t_wms_img">
      </div>
    </div>
    <div class="wmsdiv1" v-else>
      <div class="widtol">
        <div class="wmsdiv2">
          <div class="wmsdiv3">
            <img src="../assets/img/16.png" style="width:77px;height:77px;">
            <span class="wmssp1">3D建模，让数据触手可及</span>
            <span class="wmssp2">基于3D虚拟现实技术，实现3D仓库的可视化管理，<br>
            实现库房3D立体巡游。配合后台数据及掌机操作，<br>
            实时展示仓库数据，直观展示仓库当前使用状况</span>
          </div>
        </div>
      </div>
    </div>
    <!---首页弹出----->
    <mt-popup
      v-model="boxShow"
      position="right">
      <div style="display: block;padding: 40px 7%;" :style="{width:w_width+'px',height:w_height+'px'}">
        <div style="text-align: right">
          <span style="font-size: 25px" @click="boxShow=false">✕</span>
        </div>
        <div class="t_list" @click="goto('/#')">首页</div>
        <div class="t_list fx_cs" @click="listShow=true">
          TMIP产品体系
          <i class="iconfont iconlujing3278 t_icon2"></i>
        </div>
        <div v-show="listShow">
          <div class="t_t_list" @click="goto('/mes')">MES 生产管理</div>
          <div class="t_t_list" @click="boxShow=false">WMS 智慧仓储</div>
          <div class="t_t_list" @click="goto('/mtr')">MTR 物料溯源</div>
          <div class="t_t_list" @click="goto('/emv')">EMV 生产可视化</div>
        </div>
        <div class="t_list" @click="goto('/service')">服务与支持</div>
        <div class="t_list" style="border: 0" @click="goto('/aboutus')">关于我们</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import util from "../components/util";
export default util.useCommon({
  data() {
    return {
      w_width:0,
      boxShow: false,
      listShow:true,
      w_height:0
    };
  },
  watch: {},
  methods: {
    change(){
      this.boxShow = true;
      console.log(this.boxShow);
    },
    goto(add) {
      this.backtop();
      this.$router.push(add);
    },
    backtop() {
      this.$emit('gotoTop');
    }
  },
  mounted() {
    console.log(window.innerWidth);
    this.w_width = window.innerWidth;
    this.w_height = window.innerHeight;
  },
  activated() {},
});
</script>
<style scoped>
.header {
  background-image: url("../assets/img/bg/11.jpg");
  height: 520px;
}
.mesdiv4 {
  background-image: url("../assets/img/bg/2.jpg");
  height: 430px;
}
.mesdiv5 {
  padding-top: 94px;
}
.mesdiv6 {
  padding-bottom: 125px;
}
.messp7{
  line-height: 28px;
}
.wms{
  background-color: #fbfbfb;
}
.wmsdiv1{
  height: 533px;
  background-image: url("../assets/img/bg/5.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  padding-top: 80px;
}
.wmsdiv2{
  width: 471px;
  height: 376px;
  background-color: #1C2A85;
  border-radius: 10px;
  opacity: 0.9;
  padding: 63px 54px 0 69px;
}
.wmsdiv3{
  z-index: 999;
}
.wmssp1{
  display: block;
  margin: 30px 0 20px 0;
  font: normal normal bold 24px/32px Source Han Sans CN;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  line-height: 32px;
}
.wmssp2{
  font: normal normal normal 15px/28px Microsoft YaHei;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  line-height: 28px;
}
</style>
